import * as moment from 'moment';
import * as _ from 'lodash';


import { DeviceService } from 'app/shared/services/device.service';
import { OnInit, OnChanges, SimpleChanges, EventEmitter, Output, Input, Component } from '@angular/core';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { BookingService } from 'app/shared/services/booking.service';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { ITINERARY_CONTEXT } from 'app/shared/models/enums/context.enum';
import { Passenger } from 'app/shared/models/passenger.model';
import { ProductUrl } from 'app/shared/models/availability.model';
import { Router } from '@angular/router';
import { InitialDataService } from 'app/initial-data.service';
import { ApplicationError } from 'app/shared/errors/ApplicationError';
import { CartTotalService } from 'app/shared/services/cart-total.service';
import { SectorAddonsService } from '../../services/sector-addons.service';
import { AddonOption, Addon, Booking, Totals } from '../../models/booking.model';
import { TravelProductService, GetCartTotalOptions, CartItemOptions } from 'app/shared/services/travel-product.service';

@Component({
    selector: 'gaweb-purchase-total-wrapper',
    templateUrl: `./purchase-total-wrapper.component.html`
})
export class PurchaseTotalWrapperComponent implements OnInit, OnChanges {

    @Input() isPassBooking: boolean;
    @Input() booking: Booking;
    @Input() bookingGuid: string;

    processing: boolean;
    hasPurchases: boolean;
    proceedButtonText: string;

    private _addonsToPurchase: Array<Addon>;
    set addonsToPurchase(a: Array<Addon>) {
        this._addonsToPurchase = a;
        this.initialized = true;
        this.onAddonChange();
    }
    get addonsToPurchase(): Array<Addon> {
        return this._addonsToPurchase;
    }

    // @Input() totals: Totals;
    // @Input() isPassBooking: boolean;

    initialized: boolean;
    promoCode: string;
    customerWishesToUseFreeTrip: boolean;
    totals: Totals;
    loadingCartTotal: boolean;
    tcs: boolean;
    acceptedTC: boolean;
    lastClick: Date;

    readonly defaultButtonText = 'PROCEED TO PAYMENT';

    constructor(
        public initialDataService: InitialDataService,
        private localStorageService: LocalStorageService,
        private cartTotalService: CartTotalService,
        private sectorAddonsService: SectorAddonsService
    ) {
        this.totals = new Totals();
        this.loadingCartTotal = true;
        this.tcs = false;
        this.initialized = false;
        this.proceedButtonText = this.defaultButtonText;
        this.acceptedTC = false;
    }

    ngOnInit(): void {
        this.sectorAddonsService.addonCart.subscribe(addons => this.addonsToPurchase = addons)
        this.sectorAddonsService.loadingCartTotal.subscribe(lct => this.loadingCartTotal = lct)
        // const that = this;
        // $('#dataCheckbox').on('click', function () {
        //     if (that.lastClick != null && new Date().getTime() - that.lastClick.getTime() < 100) {
        //         return;
        //     }
        //     that.lastClick = new Date();

        //     if ($('#dataCheckbox').hasClass('checked')) {
        //         $('#dataCheckbox').removeClass('checked');
        //         $('#dataCheckboxInput').val('false');
        //         that.acceptedTC = false;
        //     } else {
        //         $('#dataCheckbox').addClass('checked');
        //         $('#dataCheckboxInput').val('true');
        //         that.acceptedTC = true;
        //     }
        // });
    }

    ngOnChanges(changesObj: SimpleChanges): void {
    }

    doTermsAndConditions(){
        this.acceptedTC = !this.acceptedTC;
        if(this.acceptedTC){
            if (this.lastClick != null && new Date().getTime() - this.lastClick.getTime() < 100) {
                return;
            }
            this.lastClick = new Date();
        }
    }

    getCartTotalOptions() {
        if (this.isPassBooking) {
            return this.cartTotalService.getPassCartTotalOptions(this.booking.Package, this.addonsToPurchase, this.promoCode);
        } else {
            const userData = this.initialDataService.userData,
                customerGuid = !!userData ? userData.CustomerGuid : null;

            if (this.booking.travels == null) {
                this.booking.travels = this.localStorageService.getOfflineBooking().travels;
            }

            return this.cartTotalService.getExpressCartTotalOptions(this.booking.travels,
                Booking.getPassengerCountWithExclusions(this.booking),
                this.addonsToPurchase,
                null,
                customerGuid);
        }
    };

    onAddonChange() {
        const ifPassIsInitialised = this.isPassBooking ? this.booking.Package : true;
        if(!!this.addonsToPurchase){
            var newAddons = this.addonsToPurchase.length > 0;
            if(newAddons){
                const ifPassIsInitialised = this.isPassBooking ? this.booking.Package : true;
                if (newAddons && this.initialized && ifPassIsInitialised) { // express or pass
                    this.cartTotal();
                }
            }
        }
    };

    private cartTotal() {
        const success = (data) => {
            this.totals = data;

            // TODO why is this put on the booking object?
            //                        this.store.addCartTotalToBooking(this.totals);
            this.localStorageService.saveCart(this.totals);
            this.initialized = true;
        }, error = function () {
            throw new ApplicationError('Unable to retrieve cart total.');
        }, loading = () => {
            this.sectorAddonsService.setLoadingCartTotal(true);
        }, finished = () => {
            this.sectorAddonsService.setLoadingCartTotal(false);
            this.bookingGuid = _.cloneDeep(this.booking.BookingGuid);
        };
        if (this.isPassBooking) {
            this.cartTotalService.getCartTotal(this.booking.BookingGuid, success, error, loading, finished);
        } else {
            const options = this.getCartTotalOptions();
            this.cartTotalService.postCartTotal(options, success, error, loading, finished);
        }
    }

    onProceedToPaymentClicked() {
        window.location.href = this.initialDataService.initialData.ManageBooking.PaymentUrl + '?bookingGuid=' + this.booking.BookingGuid;
    }

    pageValid() {
        return true;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/purchase-total-wrapper/purchase-total-wrapper.component.ts